import React from 'react';
import { TParamQuantileOption } from '../../../api/endpoints/SubsetOption';
import { flatMap } from 'lodash';
import { MatrixEditor } from '../../Ui/MatrixEditor';
import SelectAllControl from "../SelectAllControl";
import { TApiParameter } from "../../../api/endpoints/Parameter";
import ParameterLabel from "../../Ui/ParameterLabel";

const paramQuantileToOptions = (spec: TParamQuantileOption): Array<TParamQuantileValue> => {
  const { param, quantile } = spec.value;

  return flatMap(param, (param, index) => {
    let quantiles;

    if (typeof quantile[0] === 'string') {
      quantiles = quantile as Array<string>;
    } else {
      quantiles = quantile[index] as Array<string>;
    }

    return quantiles.map(quantile => {
      return ({
        param,
        quantile
      });
    });
  });
};

export type TParamQuantileValue = {
  param: string,
  quantile: string;
}

const columnLabel = (option: TParamQuantileValue) => option.param;
const rowLabel = (option: TParamQuantileValue) => option.quantile;

const ParamsQuantileSelector = (props: {
  spec: TParamQuantileOption;
  values: Array<TParamQuantileValue>;
  params: { [shortname: string]: TApiParameter };
  onChange: (values: Array<TParamQuantileValue>) => void
}) => {
  const { spec, values, params, onChange } = props;
  const options = paramQuantileToOptions(spec);

  return (
    <div>
      <SelectAllControl onChange={onChange} values={options} className="margin-bottom-xs" />

      <MatrixEditor
        options={options}
        selection={values}
        setSelection={onChange}
        optionToColumn={columnLabel}
        optionToRow={rowLabel}
        renderColumn={shortname => <ParameterLabel label={shortname} param={params[shortname.toLowerCase()]} />}
        needsFocus={false}
        acknowledgeFocusRequest={() => undefined}
        columnButtonContainsFocusableElement
      />
    </div>
  );
};

export default ParamsQuantileSelector;
